import React, { useEffect, useState } from "react";
import { Row, Col, Table } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import { withRouter } from "react-router-dom";
import "./PipelineContainer.css";

import { httpGetVendorStatusCount } from "../../../../service/httpClient";

const PipelineContainer = ({ match }) => {
  const [responseData, setResponseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let currentYear = match.params.year;

    if (currentYear) {
      httpGetVendorStatusCount(currentYear)
        .then((response) => {
          setResponseData(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [match.params.year]);

  return (
    <Row className="justify-content-md-center row-container">
      <Col lg={9} md={12} sm={12} xs={12}>
        <div className="pipeline-table-title">Vendor Pipeline Status</div>
        <LoadingOverlay active={isLoading} spinner>
          <div style={{ minHeight: 270 }}>
            {!isLoading &&
              responseData &&
              !Object.keys(responseData).length && (
                <div>There are no records to display at this time!</div>
              )}
            {!isLoading && responseData && Object.keys(responseData).length && (
              <>
                <Table
                  responsive
                  bordered
                  hover
                  className="pipeline-container-table"
                >
                  <thead>
                    <tr>
                      <th>Vendor Registration</th>
                      <th>Vendor Submission</th>
                      <th>Merchant Approved</th>
                      <th>Documents Submitted</th>
                      <th>DBM Approved</th>
                      <th>Accounts Payable Approved</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{responseData.vendorRegistration}</td>
                      <td>{responseData.vendorSubmission}</td>
                      <td>{responseData.merchantApproved}</td>
                      <td>{responseData.documentsSubmitted}</td>
                      <td>{responseData.dbmApproved}</td>
                      <td>{responseData.accountsPayableApproved}</td>
                    </tr>
                  </tbody>
                </Table>
                <Table
                  responsive
                  bordered
                  hover
                  className="pipeline-container-table"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>In Process</th>
                      <th>OB Complete</th>
                      <th>On Hold</th>
                      <th>Live</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>VDF (Direct EDI)</td>
                      <td>{responseData.directEdiInProcess}</td>
                      <td>{responseData.directEdiCompleted}</td>
                      <td>{responseData.directEdiOnHold}</td>
                      <td>{responseData.directEdiLive}</td>
                    </tr>
                    <tr>
                      <td>VDF (Commerce Hub)</td>
                      <td>{responseData.chubInProcess}</td>
                      <td>{responseData.chubCompleted}</td>
                      <td>{responseData.chubOnHold}</td>
                      <td>{responseData.chubLive}</td>
                    </tr>
                    <tr>
                      <td>Big Ticket</td>
                      <td>{responseData.directEdiRDSInProcess}</td>
                      <td>{responseData.directEdiRDSCompleted}</td>
                      <td>{responseData.directEdiRDSOnHold}</td>
                      <td>{responseData.directEdiRDSLive}</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        </LoadingOverlay>
      </Col>
    </Row>
  );
};

export default withRouter(PipelineContainer);
